<!--
// app/pages/[region]/TierList.vue
-->
<script setup lang="ts">
import LayoutTierListKwcClubs from "~/app/components/pages/region-tier-list/LayoutTierListKwcClubs.vue";
import { useRegions } from "~/app/composables/regions";
import LayoutTierListKwcNations from "~/app/components/pages/region-tier-list/LayoutTierListKwcNations.vue";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]/tier-list",
    es: "/[region]/tier-list",
    de: "/[region]/tier-list",
    fr: "/[region]/tier-list",
    it: "/[region]/tier-list",
    pt: "/[region]/tier-list",
  },
});

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-spain",
    "not-found-queens",
    "not-found-italy",
    "not-found-king-of-kings-nations",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
  ],
});

useHead({
  script: [
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
      tagPosition: "head",
      tagPriority: "high",
    },
  ],
});

const { isWorldCup, isNations } = useRegions();
</script>

<template>
  <layout-tier-list-kwc-clubs v-if="isWorldCup"></layout-tier-list-kwc-clubs>
  <layout-tier-list-kwc-nations v-else-if="isNations"></layout-tier-list-kwc-nations>
</template>

<style scoped></style>
